/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-02-17 16:40:59
 * @LastEditors: 刘小博
 * @Description:
 * 公用路由
 */
const commonRouter = [
  // 个人中心
  {
    path: '/user/center',
    name: 'userCenter',
    component: () =>
      import(/*webpackChunkName:"user" */ '@/views/user/Center.vue'),
    meta: {
      SecondaryMenu: '', //二级菜单
      title: '个人中心',
    },
  },
  // 存储日志
  {
    path: '/master-data-system/history-data/log/:meta_type/:json',
    name: 'masterDataSystemHistoryDataSaveLog',
    component: () =>
      import(
        /*webpackChunkName:"masterDataSystemHistoryDataSaveLog" */
        '@/views/masterDataSystem/historyData/Log.vue'
      ),
  },
  // 我的上传
  {
    path: '/user/my-upload',
    name: 'userMyUpload',
    component: () =>
      import(/*webpackChunkName:"user" */ '@/views/MyUpload.vue'),
    meta: {
      SecondaryMenu: '', //二级菜单
      title: '我的导入',
    },
  },
]

export default commonRouter
